import { createVNode as i, mergeProps as w } from "vue";
import y from "./IconBase.js";
import { setTwoToneColor as c, getTwoToneColor as x } from "./twoTonePrimaryColor.js";
import { normalizeTwoToneColors as I } from "../utils.js";
c("#1890ff");
const n = (m, p) => {
  const {
    class: t,
    icon: o,
    spin: s,
    rotate: e,
    tabindex: d,
    twoToneColor: f,
    onClick: a,
    ...l
  } = {
    ...m,
    ...p.attrs
  }, C = {
    anticon: !0,
    [`anticon-${o.name}`]: Boolean(o.name),
    [t]: t
  }, T = s === "" || !!s || o.name === "loading" ? "anticon-spin" : "";
  let r = d;
  r === void 0 && a && (r = -1, l.tabindex = r);
  const g = e ? {
    msTransform: `rotate(${e}deg)`,
    transform: `rotate(${e}deg)`
  } : void 0, [b, u] = I(f);
  return i("span", w({
    role: "img",
    "aria-label": o.name
  }, l, {
    onClick: a,
    class: C
  }), [i(y, {
    class: T,
    icon: o,
    primaryColor: b,
    secondaryColor: u,
    style: g
  }, null)]);
};
n.props = {
  spin: Boolean,
  rotate: Number,
  icon: Object,
  twoToneColor: String
};
n.displayName = "PfIcon";
n.inheritAttrs = !1;
n.getTwoToneColor = x;
n.setTwoToneColor = c;
export {
  n as default
};
